import { acceptHMRUpdate, defineStore } from "pinia";
import { useCoreStore } from "@/store/coreStore";
import { setLocale } from "@/i18n/i18n";
import { fetchUserSettings } from "@/utils/userSettings";
import { checkKeycode } from "@/utils/loginCheck";
import { EventSourcePolyfill } from "event-source-polyfill";
import axiosInstance from "@/utils/http.js";
const axios = axiosInstance;

const LOGGED_IN_KEY = "loggedIn";

export const useAuthStore = defineStore("auth", {
  // Controle de sessao do lado do CLIENTE: passou pela tela de login, esta
  // logado, e assim fica ate clicar em sair. Nao expira e nao e seguranca -
  // qualquer um edita a chave no devtools. Serve para nao mostrar a aplicacao
  // a quem nunca entrou, e para o botao de sair ter efeito.
  state: () => ({
    authenticated: localStorage.getItem(LOGGED_IN_KEY) === 'true',
    userId: undefined,
    apiKey: undefined,
    userInfo: undefined,
  }),
  getters: {
    isAuthenticated: (state) => state.authenticated,
    getUserId: (state) => state.userId,
    getUserEmail: (state) => state.email,
    getApiKey: (state) => state.apiKey,
  },
  actions: {
    // "ok" | "denied" | "unavailable". So o "ok" entra: keycode errado nao
    // autentica, e sem poder verificar tambem nao - a porta fica fechada.
    async login(payload) {
      const status = await checkKeycode(payload.email, payload.keycode);
      if (status !== "ok") return status;

      const oldUserInfo = JSON.parse(localStorage.getItem("userInfo")) || {};

      this.userInfo = {
        ...oldUserInfo,
        email: payload.email,
        selectedProduct: payload.selectedProduct,
        keycode: payload.keycode,
        // firstLogin: oldUserInfo.firstLogin || new Date().toISOString(),
      };

      localStorage.setItem("userInfo", JSON.stringify(this.userInfo));
      this.authenticated = true;
      localStorage.setItem(LOGGED_IN_KEY, "true");

      // Antes de quem chamou ler o `getSelectedUrl`: e esta chamada que pode
      // trocar o produto de destino.
      await this.loadUserSettings(payload.email);

      return "ok";
    },

    // Preferencias vindas do backend (hoje o mock_api). Falha aqui nao impede
    // a entrada: fica valendo o que ja estava no localStorage.
    async loadUserSettings(email) {
      if (!email) return null;

      try {
        const settings = await fetchUserSettings(email);

        this.userInfo = { ...this.userInfo, settings };
        localStorage.setItem("userInfo", JSON.stringify(this.userInfo));

        if (settings.locale) setLocale(settings.locale);
        useCoreStore().applyUserSettings(settings);

        return settings;
      } catch (e) {
        return null;
      }
    },
    async getAuth() {
      const savedUserInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
      this.userInfo = savedUserInfo;
      const needsFirstLogin = !savedUserInfo.firstLogin;
      return needsFirstLogin;
    },
    async confirmFirstLogin() {
      this.userInfo = {
        ...this.userInfo,
        firstLogin: new Date().toISOString(),
      };
      localStorage.setItem("userInfo", JSON.stringify(this.userInfo));
    },
    // localStorage.setItem("psw", payload.password)
    //for the moment, save login credentials on localStorage
    /* const url = `${CLEARFXAI_API_URL}/${ENTITY_PATH}/user_lookup/${payload.username}`
      return axios.get(url, {
        headers: {
          Password: payload.password
        }
      })
        .then(response => {
          const data = response.data
          this.userRole = data.role
          this.email = data.email
          this.updateTitle()
          return response
        })*/

    logout() {
      this.authenticated = false;
      localStorage.removeItem(LOGGED_IN_KEY);
      const userId = this.getUserId;
      /*   const url = `${CLEARFXAI_API_URL}/${AUTH_PATH}/logout/${userId}`
      return axios.delete(url)
        .then(() => {
          this.removeSessionLocalStorage()
          this.userRole = undefined
          this.updateTitle()
        });
    */
    },
    loadAuthenticatedAndUserIdStateFromLocalStorage() {
      let userId = localStorage.getItem("userId");
      let userRole = localStorage.getItem("userRole");
      let authenticated = false;
      if (userId) {
        authenticated = true;
      }
      this.authenticated = authenticated;
      this.userId = userId;
      this.userRole = userRole;
      this.updateTitle();
    },
    saveSessionLocalStorage(data) {
      localStorage.setItem("userName", data.name);
      localStorage.setItem("userId", data.id);
      localStorage.setItem("userRole", data.role);
      localStorage.setItem("brokerId", data.broker);
      localStorage.setItem("companyId", data.company);
      localStorage.setItem("userEmail", data.email);
      localStorage.setItem("bankId", data.bank);
      this.userRole = data.role;
    },
    removeSessionLocalStorage() {
      localStorage.removeItem("userName");
      localStorage.removeItem("userId");
      localStorage.removeItem("userRole");
      localStorage.removeItem("brokerId");
      localStorage.removeItem("companyId");
      localStorage.removeItem("userEmail");
      localStorage.removeItem("apiKey");
      localStorage.removeItem("bankId");
    },
    getUserRoleFromLocalStorage() {
      const data = localStorage.getItem("userRole");
      return data;
    },
    changePasswordUser(new_password) {
      const psw = localStorage.getItem("psw");
      const email = localStorage.getItem("userEmail");
      const data = {
        passwd: new_password,
      };
      /*  const url = `${CLEARFXAI_API_URL}/${ENTITY_PATH}/user_update/${email}`
      return axios.put(url, data, {
        headers: {
          SECRETKEY: SECRETKEY,
          Password: psw
        }
      })*/
    },
  },
});

// Sem isto, editar uma action com o `serve` no ar troca o modulo mas NAO troca
// a store ja instanciada: a tela continua rodando a versao antiga ate um reload
// inteiro, e o sintoma e uma correcao que "nao pegou".
if (module.hot) {
  module.hot.accept(acceptHMRUpdate(useAuthStore, module.hot));
}
